/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { B as Backdrop, d as defineCustomElement$1 } from './p-Bhnhnzjz.js';

const IonBackdrop = Backdrop;
const defineCustomElement = defineCustomElement$1;

export { IonBackdrop, defineCustomElement };
